export default __webpack_public_path__ + "static/0122-834d1a3658a3131bf045987827b62261.png";